export default __webpack_public_path__ + "static/stars-742d5dd72539248a02fef8ab444796e3.png";